import React from 'react';
import gql from 'graphql-tag';
import useMutation from '../../modules/react/hooks/useMutation';
import ApplyPageLayoutModal from '../components/ApplyPageLayoutModal';

const APPLY_PAGE_LAYOUT = gql`
  mutation ApplyPageLayout($sourcePageId: ID!, $destinationPageId: ID!) {
    applyPageLayout(sourcePageId: $sourcePageId, destinationPageId: $destinationPageId) {
      targetPage {
        id
        lastUpdated
      }
      userErrors {
        code
        message
      }
    }
  }
`;

const propTypes = {};
const defaultProps = {};

const ApplyPageLayout = (props) => {
  const [applyPageLayout, { data, loading, error }] = useMutation(APPLY_PAGE_LAYOUT);

  const onConfirm = ({ sourcePageId, destinationPageId }) => {
    applyPageLayout({ variables: { sourcePageId, destinationPageId } });
  };

  const errors = [];
  if (error) {
    errors.push(error.message);
  }

  if (data?.applyPageLayout?.userErrors?.length) {
    errors.push(data.applyPageLayout.userErrors.map(({ message }) => message));
  }

  return (
    <ApplyPageLayoutModal
      {...props}
      onConfirm={onConfirm}
      loading={loading}
      submitErrors={errors}
    />
  );
};
ApplyPageLayout.propTypes = propTypes;
ApplyPageLayout.defaultProps = defaultProps;

export default ApplyPageLayout;
